<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="姓名" prop="realName">
                <a-input v-model="queryParam.realName" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="手机号" prop="mobile">
                <a-input v-model="queryParam.mobile" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="身份证号" prop="idCard">
                <a-input v-model="queryParam.idCard" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="预约企业" prop="companyId">
                <a-select
                  v-model="queryParam.companyId"
                  placeholder="请选择"
                  optionFilterProp="children"
                  showSearch>
                  <a-select-option v-for="(company,index) in companyList" :key="index" :value="company.id">
                    {{ company.companyName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="预约岗位" prop="postName">
                  <a-input v-model="queryParam.postName" placeholder="请输入" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="面试时间" prop="interviewDate">
                  <a-range-picker
                    style="width: 100%"
                    v-model="interviewDate"
                    valueFormat="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="入职岗位" prop="workName">
                  <a-input v-model="queryParam.workName" placeholder="请输入" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="入职时间" prop="entryDate">
                  <a-range-picker
                    style="width: 100%"
                    v-model="entryDate"
                    valueFormat="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="离职时间" prop="dimissionDate">
                  <a-range-picker
                    style="width: 100%"
                    v-model="dimissionDate"
                    valueFormat="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="推荐官" prop="referralsName">
                  <a-input v-model="queryParam.referralsName" placeholder="请输入" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="推荐官专员" prop="topReferralsName">
                  <a-input v-model="queryParam.topReferralsName" placeholder="请输入" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="招聘专员" prop="topUserName">
                  <a-input v-model="queryParam.topUserName" placeholder="请输入" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="推荐官是否参与" prop="isReferralsTake">
                  <a-select placeholder="请选择" v-model="queryParam.isReferralsTake" allow-clear>
                    <a-select-option value="0">否</a-select-option>
                    <a-select-option value="1">是</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="报备时间" prop="createDate">
                  <a-range-picker
                    style="width: 100%"
                    v-model="createDate"
                    valueFormat="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="状态" prop="status">
                  <a-select placeholder="请选择" v-model="queryParam.status" allow-clear>
                    <a-select-option value="1">报备中</a-select-option>
                    <a-select-option value="2">面试体检中</a-select-option>
                    <a-select-option value="3">面试未到</a-select-option>
                    <a-select-option value="4">面试失败</a-select-option>
                    <a-select-option value="5">面试成功</a-select-option>
                    <a-select-option value="6">面试成功体检失败</a-select-option>
                    <a-select-option value="7">面试成功体检失败需复检</a-select-option>
                    <a-select-option value="8">面试成功未体检</a-select-option>
                    <a-select-option value="9">体检成功未入职</a-select-option>
                    <a-select-option value="10">复检成功并入职</a-select-option>
                    <a-select-option value="11">复检成功未入职</a-select-option>
                    <a-select-option value="12">复检失败</a-select-option>
                    <a-select-option value="13">离职</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="所属招聘部门" prop="topUserDept">
                  <a-tree-select
                    v-model="topUserDept"
                    style="width: 100%"
                    show-search
                    allow-clear
                    multiple
                    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                    :tree-data="postOptions"
                    placeholder="请选择"
                    :replaceFields="{ children: 'children', title: 'postName', key: 'id', value: 'id' }"
                    tree-default-expand-all
                    tree-node-filter-prop="postName"
                  >
                  </a-tree-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="所属推荐部门" prop="topReferralsUserDept">
                  <a-tree-select
                    v-model="topReferralsUserDept"
                    style="width: 100%"
                    show-search
                    allow-clear
                    multiple
                    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                    :tree-data="postOptions"
                    placeholder="请选择"
                    :replaceFields="{ children: 'children', title: 'postName', key: 'id', value: 'id' }"
                    tree-default-expand-all
                    tree-node-filter-prop="postName"
                  >
                  </a-tree-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search"/>查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo"/>重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="danger" :disabled="multiple" @click="handleDelete">
          <a-icon type="delete"/>
          批量删除
        </a-button>
        <a-button type="primary" @click="handleExport">
          <a-icon type="download"/>
          导出
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"/>
      </div>
      <set-status-form
        ref="setStatusForm"
      />
      <add-user-form
        ref="addUserForm"
      />
      <upload-form
        ref="uploadForm"
      />
      <!-- 查看/修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <follow-create-form
        ref="followCreateForm"
      />
      <report-create-form
        ref="reportCreateForm"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 3000 }"
      >
        <span slot="interviewTime" slot-scope="text, record">
          {{ parseTime(record.interviewTime) }}
        </span>
        <span slot="entryTime" slot-scope="text, record">
          {{ parseTime(record.entryTime) }}
        </span>
        <span slot="dimissionTime" slot-scope="text, record">
          {{ parseTime(record.dimissionTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="record.status" color="blue">
            {{
              record.status === 1 ? '报备中' :
                record.status === 2 ? '面试体检中' :
                  record.status === 3 ? '面试未到' :
                    record.status === 4 ? '面试失败' :
                      record.status === 5 ? '面试成功' :
                        record.status === 6 ? '面试成功体检失败' :
                          record.status === 7 ? '面试成功体检失败需复检' :
                            record.status === 8 ? '面试成功未体检' :
                              record.status === 9 ? '体检成功未入职' :
                                record.status === 10 ? '复检成功并入职' :
                                  record.status === 11 ? '复检成功未入职' :
                                    record.status === 12 ? '复检失败' :
                                      record.status === 13 ? '离职' : ''
            }}
          </a-tag>
          <div v-else>
            暂无
          </div>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical"/>
          <a @click="$refs.createForm.handleUpdate1(record, undefined)">
            <a-icon type="edit"/>查看/编辑
          </a>
          <a-divider type="vertical"/>
          <a @click="handleDelete(record)">
            <a-icon type="delete"/>删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {pageReport, delReport} from '@/api/user/report'
import { queryPostList } from '@/api/system/post'
import {listCompany} from '@/api/user/company'
import CreateForm from './modules/CreateForm'
import FollowCreateForm from './modules/FollowCreateForm'
import ReportCreateForm from './modules/ReportCreateForm'
import {tableMixin} from '@/store/table-mixin'
import AddUserForm from './modules/AddUserForm'
import UploadForm from './modules/UploadForm'
import SetStatusForm from '@/views/biz/user/modules/SetStatusForm'

export default {
  name: 'ReportIndex',
  components: {
    SetStatusForm,
    UploadForm,
    AddUserForm,
    CreateForm,
    FollowCreateForm,
    ReportCreateForm
  },
  mixins: [tableMixin],
  dicts: ['sys_user_sex', 'sys_notice_status', 'sys_enable_disable'],
  data() {
    return {
      list: [],
      operateTitle: null,
      operateOpen: false,
      operateType: null,
      userId: null,
      interviewType: null,
      selectedRowKeys: [],
      selectedRows: [],
      postId: null,
      entryTime: null,
      dimissionTime: null,
      entryWork: null,
      remark: null,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      companyList: [],
      loading: false,
      interviewDate: null,
      entryDate: null,
      dimissionDate: null,
      createDate: null,
      postOptions: [],
      topUserDept: [],
      topReferralsUserDept: [],
      total: 0,
      // 查询参数
      queryParam: {
        topUserDept: null,
        topReferralsUserDept: null,
        realName: null,
        mobile: null,
        birthday: null,
        sex: null,
        idCard: null,
        companyId: null,
        postName: null,
        startInterviewTime: null,
        endInterviewTime: null,
        workName: null,
        startEntryTime: null,
        endEntryTime: null,
        startDimissionTime: null,
        endDimissionTime: null,
        referralsName: null,
        topReferralsName: null,
        topUserName: null,
        isReferralsTake: null,
        startCreateTime: null,
        endCreateTime: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '姓名',
          dataIndex: 'realName',
          ellipsis: true,
          width: 120,
          fixed: 'left',
          align: 'center'
        },
        {
          title: 'ID',
          dataIndex: 'id',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '手机号',
          dataIndex: 'mobile',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        // {
        //   title: '出生年月',
        //   dataIndex: 'birthday',
        //   ellipsis: true,
        //   width: 180,
        //   align: 'center'
        // },
        // {
        //   title: '性别',
        //   dataIndex: 'sex',
        //   ellipsis: true,
        //   width: 80,
        //   align: 'center',
        //   customRender: function (sex) {
        //     if (sex === 0) {
        //       return '保密'
        //     } else if (sex === 1) {
        //       return '男'
        //     } else if (sex === 2) {
        //       return '女'
        //     }
        //   }
        // },
        {
          title: '身份证号',
          dataIndex: 'idCard',
          ellipsis: true,
          width: 220,
          align: 'center'
        },
        {
          title: '预约企业',
          dataIndex: 'companyName',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '预约岗位',
          dataIndex: 'postName',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '面试时间',
          dataIndex: 'interviewTime',
          scopedSlots: {customRender: 'interviewTime'},
          width: 200,
          align: 'center'
        },
        {
          title: '入职岗位',
          dataIndex: 'workName',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '入职时间',
          dataIndex: 'entryTime',
          scopedSlots: {customRender: 'entryTime'},
          width: 200,
          align: 'center'
        },
        {
          title: '离职时间',
          dataIndex: 'dimissionTime',
          scopedSlots: {customRender: 'dimissionTime'},
          width: 200,
          align: 'center'
        },
        {
          title: '所属招聘部门',
          dataIndex: 'topUserDept',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '招聘专员',
          dataIndex: 'topUserName',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '推荐官',
          dataIndex: 'referralsUserName',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '所属推荐部门',
          dataIndex: 'topReferralsUserDept',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '推荐官专员',
          dataIndex: 'topReferralsUserName',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '推荐官是否参与',
          dataIndex: 'isReferralsTake',
          ellipsis: true,
          width: 120,
          align: 'center',
          customRender: function (isReferralsTake) {
            if (isReferralsTake === 1) {
              return '是'
            } else if (isReferralsTake === 0) {
              return '否'
            }
          }
        },
        {
          title: '报备时间',
          dataIndex: 'createTime',
          scopedSlots: {customRender: 'createTime'},
          width: 200,
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 120,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: {customRender: 'status'},
          width: 120,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          fixed: 'right',
          scopedSlots: {customRender: 'operation'},
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.queryPostList()
    this.getList()
    this.queryCompanyList()
  },
  computed: {},
  watch: {},
  methods: {
    queryPostList() {
      queryPostList().then(response => {
        this.postOptions = response.data
      })
    },
    queryCompanyList() {
      const param = {}
      listCompany(param).then(response => {
        this.companyList = response.data
      })
    },
    /** 查询用户信息列表 */
    getList() {
      this.loading = true
      pageReport(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      if (this.interviewDate) {
        this.queryParam.startInterviewTime = this.interviewDate[0]
        this.queryParam.endInterviewTime = this.interviewDate[1]
      }
      if (this.entryDate) {
        this.queryParam.startEntryTime = this.entryDate[0]
        this.queryParam.endEntryTime = this.entryDate[1]
      }
      if (this.dimissionDate) {
        this.queryParam.startDimissionTime = this.dimissionDate[0]
        this.queryParam.endDimissionTime = this.dimissionDate[1]
      }
      if (this.createDate) {
        this.queryParam.startCreateTime = this.createDate[0]
        this.queryParam.endCreateTime = this.createDate[1]
      }
      if (this.topUserDept) {
        this.queryParam.topUserDept = this.topUserDept.join(',')
      }
      if (this.topReferralsUserDept) {
        this.queryParam.topReferralsUserDept = this.topReferralsUserDept.join(',')
      }
      this.queryParam.pageNum = 1
      this.getList()
      this.queryCompanyList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.topUserDept = []
      this.topReferralsUserDept = []
      this.interviewDate = null
      this.entryDate = null
      this.dimissionDate = null
      this.createDate = null
      this.queryParam = {
        topUserDept: null,
        topReferralsUserDept: null,
        realName: null,
        mobile: null,
        birthday: null,
        sex: null,
        idCard: null,
        companyId: null,
        postName: null,
        startInterviewTime: null,
        endInterviewTime: null,
        workName: null,
        startEntryTime: null,
        endEntryTime: null,
        startDimissionTime: null,
        endDimissionTime: null,
        referralsName: null,
        topReferralsName: null,
        topUserName: null,
        isReferralsTake: null,
        startCreateTime: null,
        endCreateTime: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleStatus(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$refs.setStatusForm.handleAdd(ids)
      that.onSelectChange([], [])
      that.getList()
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          const data = []
          that.ids.map(id => data.push({'id': id}))
          return delReport(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download('user/user-report/export', {
            ...that.queryParam
          }, `报备记录_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    }
  }
}
</script>
